

import React from 'react';
import styles from './Sidebar.module.css';
import SidebarToggleButton from '../../Components/SidebarToggleButton/SidebarToggleButton';
import SidebarItem from '../../Components/SidebarItem/SidebarItem';
import GearIcon from '../../Components/Icons/GearIcon';
import HomeIcon from '../../assets/icons/home.svg';
import AboutIcon from '../../assets/icons/about.svg';
import ProfileIcon from '../../assets/icons/profile.svg';
import PostIcon from '../../assets/icons/post.svg';
import ToolsIcon from '../../assets/icons/tools.svg';
import { useAuth } from '../../firebase/AuthContext';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthUser, selectIsAuthenticated } from '../../store/slices/authSlice';
import { toggleSidebar } from '../../store/slices/uiSlice';
import { UserNameDisplay } from '../../Components';

const Sidebar = ({ sidebarWidth, collapsedSidebarWidth = '48px', headerHeight, headerPadding, useSidebarToggle }) => {
  const collapsed = useSelector(state => state.ui.sidebarCollapsed);
  const dispatch = useDispatch();
  const ctx = useAuth() || { user:null, isAuthenticated:false }
  const rUser = useSelector(selectAuthUser)
  const rIs = useSelector(selectIsAuthenticated)
  const user = rUser || ctx.user
  const isAuthenticated = (rIs !== undefined ? rIs : ctx.isAuthenticated)
  const currentWidth = collapsed ? collapsedSidebarWidth : sidebarWidth;

  return (
    <div
      className={styles.container}
      style={{
        '--sidebar-width': currentWidth,
        '--header-height': headerHeight,
        '--header-padding': headerPadding
      }}
    >
      {useSidebarToggle && (
        <div style={{ width: '100%' }}>
          <SidebarToggleButton collapsed={collapsed} onClick={() => dispatch(toggleSidebar())} />
        </div>
      )}
         <div
           style={{
             padding: collapsed ? '8px 4px' : '12px 16px',
             fontSize: 12,
             opacity: 0.8,
             // トグルボタンが absolute で左上に被るため、展開時のみ余白を空ける
             ...(useSidebarToggle && !collapsed ? { marginLeft: '60px' } : {})
           }}
         >
           <UserNameDisplay
             prefix={isAuthenticated ? 'ようこそ' : ''}
             fallback="ゲスト"
             maxLength={collapsed ? 14 : 32}
           />
         </div>
         <ul
           className={`${styles.menu} ${collapsed ? styles.collapsed : ''}`}
           style={{ marginTop: useSidebarToggle ? '8px' : 0 }}
         >
          <SidebarItem collapsed={collapsed} to="/" icon={<img src={HomeIcon} alt="home" width={20} height={20} />}>ホーム</SidebarItem>
          <SidebarItem collapsed={collapsed} to="/post" icon={<img src={PostIcon} alt="post" width={20} height={20} />}>投稿</SidebarItem>
          {/* <SidebarItem collapsed={collapsed} to="/tools" icon={<img src={ToolsIcon} alt="tools" width={20} height={20} />}>道具保管</SidebarItem> */}
          <SidebarItem collapsed={collapsed} to="/tools/list" icon={<span style={{fontSize:20}}>📋</span>}>道具一覧</SidebarItem>
          <SidebarItem collapsed={collapsed} to="/profile" icon={<img src={ProfileIcon} alt="profile" width={20} height={20} />}>プロフィール</SidebarItem>
          <SidebarItem collapsed={collapsed} to="/settings" icon={<GearIcon size={20} />}>設定</SidebarItem>
          {isAuthenticated ? (
            <SidebarItem collapsed={collapsed} to="/signout" icon={<span style={{ fontSize: 18 }}>🚪</span>}>サインアウト</SidebarItem>
          ) : (
            <>
              <SidebarItem collapsed={collapsed} to="/signin" icon={<span style={{ fontSize: 18 }}>🔐</span>}>サインイン</SidebarItem>
              <SidebarItem collapsed={collapsed} to="/reset-password" icon={<span style={{ fontSize: 18 }}>✉️</span>}>PWリセット</SidebarItem>
            </>
          )}
        </ul>
    </div>
  );
};

export default Sidebar
